export const NOTIFY_UPDATA_EVENT = 'NOTIFY_UPDATA_EVENT' // 消息通知更新
export const SHOW_NOTIFY_EVENT = 'SHOW_NOTIFY_EVENT' // 展示消息通知
